<template>
  <div class="ConfInter">
    <div class="titlePage">Reporte Ordenes liquidadas por periodo</div>
    <va-notification color="danger" v-if="refNoData" class="refNoData">No se encuentran datos en este momento.</va-notification>
    <div class="listData">
      <DataList
        :InfoView="this.DLDataList"
        :HeadTable="this.HDDataList"
        :filterData="this.FilterData"
        v-if="renderComponent1"
      />
    </div>
  </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'
import DataList from '@/components/data-tables/DataReportOrdenes.vue'

export default {
  name: 'ReportInter',
  data () {
    return {
      FilterData: [
        {
          ListPrograms: [],
          ListFaculty: [],
        },
      ],
      HDDataList: [
        {
          name: 'periodo',
          title: 'Periodo',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'orden',
          title: 'Orden',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'doC_IDENTIDAD',
          title: 'Doc IDENTIDAD',
          width: '10%',
        },
        {
          name: 'documento',
          title: 'Docuemnto',
          width: '20%',
        },
        {
          name: 'organizacion',
          title: 'Organización',
          width: '20%',
        },
        {
          name: 'tipO_ORDEN',
          title: 'Tipo Orden',
          width: '20%',
        },
        {
          name: 'descuento',
          title: 'Descuento',
          width: '20%',
        },
        {
          name: 'tipO_ENTREGA',
          title: 'Tipo Entrega',
          width: '20%',
        },
        {
          name: 'fechA_ORDEN',
          title: 'Fecha Orden',
          width: '20%',
        },
        {
          name: 'fechA_LIQUIDACION',
          title: 'Fecha Liquidación',
          width: '20%',
        },
        {
          name: 'entregA_PARCIAL',
          title: 'Entrega Parcial',
          width: '20%',
        },
        {
          name: 'estado',
          title: 'Estado',
          width: '20%',
        },
        {
          name: 'cliente',
          title: 'Cliente',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'ordeN_COMPRA',
          title: 'Orden Compra',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'clientE_SOLICITADO',
          title: 'Cliente Solicitado',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'centrO_COSTO',
          title: 'Centro Costo',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'fondo',
          title: 'Fondo',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'fechA_VENCIMIENTO',
          title: 'Fecha Vencimiento',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'valoR_BRUTO',
          title: 'Valor Bruto',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'valoR_DESCUENTO',
          title: 'Valor Descuento',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'valoR_IVA',
          title: 'Valor IVA',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'valoR_TOTAL',
          title: 'Valor Total',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'grupo',
          title: 'Grupo',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'generA_MORA',
          title: 'Genera Mora',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'tasA_INTERES_MORA',
          title: 'Tasa Interes Mora',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'fuentE_FUNCION',
          title: 'Fuente Función',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'ciclo',
          title: 'ciclo',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'documentO_SALDO',
          title: 'Documento Saldo',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'creditoS_ACADEMICOS',
          title: 'Creditos Academicos',
          dataClass: 'text-left',
          width: '10%',
        },
        {
          name: 'moneda',
          title: 'moneda',
          dataClass: 'text-left',
          width: '10%',
        },
      ],
      DLDataList: [],
      refNoData: false,
      caseModel: [],
      formUpdate: [],
      renderComponent1: false,
      renderComponent2: false,
    }
  },
  components: {
    DataList,
  },
  methods: {
    loadList () {
      let loader = this.$loading.show()
      debugger
      var OrdenData = IberoHelpers.getOrdenesdata(this.$store, 1, 0, 0)
      OrdenData.then(Response => {
        if (Response.data) {
          debugger
          this.DLDataList = Response.data

          IberoHelpers.forceRerender1(this)
        } else {
          this.refNoData = true
        }
        loader.hide()
      })

      // Cargar peridos Aparte otra consulta mas lite
      var ListPeriods = IberoHelpers.getPeriodList(this.$store)
      ListPeriods.then(Response => {
        if (Response.data) {
          debugger
          this.FilterData.ListFaculty = IberoHelpers.uniqueBy(
            Response.data,
            'desPeriod'
          )
        } else {
          // this.refNoData = true
        }
        loader.hide()
      })
    },
  },
  created: function () {
    this.loadList()
  },
}
</script>